import { render } from "./ReportManagement.vue?vue&type=template&id=d8712ce2&scoped=true"
import script from "./ReportManagement.vue?vue&type=script&lang=js"
export * from "./ReportManagement.vue?vue&type=script&lang=js"

import "./ReportManagement.vue?vue&type=style&index=0&id=d8712ce2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8712ce2"]])

export default __exports__